import React from 'react'
import PropTypes from 'prop-types'
import CallToActionContainer from 'LiveBoard/containers/CallToActionContainer'
import { CTA_AREAS } from 'LiveBoard/components/shared/CallToAction/constants'

import './style.css.scss'

const CtaRenderer = (props) => {
  return (
    <CallToActionContainer
      config={{...props.ctaData}}
      area={CTA_AREAS.sideBySide}
      themeColorHex={props.themeColorHex}
      renderCustomButton={(onClick) => (
        <span
          className="paragraph-cta-link"
          onClick={onClick}>
          {props.ctaData.text}
        </span>
      )} />
  )
}

CtaRenderer.propTypes = {
  ctaData: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default CtaRenderer